import React, {
  useCallback,
} from 'react';
import {
  shallowEqual,
  useSelector,
} from 'react-redux';

import {
  coreSelectors,
} from '@gymcloud/core';

import {
  Flex,
} from 'web-styled';

import Folder from './Folder';

type Props = {
  folderName: string,
  selectedId: number,
  onSelect: { (id: number): void },
};

const ThreeFolders = ({
  selectedId,
  folderName,
  onSelect,
}: Props) => {
  const mapState = useCallback(state => ({
    folders: coreSelectors.getTreeFolders(
      folderName,
    )(state),
  }), [folderName]);

  const { folders } = useSelector(mapState, shallowEqual);

  return (
    <Flex
      column
      scrollY
      shrink="0"
      spacing={10}
      width="100%"
      style={{
        maxHeight: 300,
      }}
    >
      <Folder
        folder={folders}
        initialState
        selectedId={selectedId}
        onSelect={onSelect}
      />
    </Flex>
  );
};

export default ThreeFolders;
